// extracted by mini-css-extract-plugin
module.exports = {"headContainer":"profile-header_headContainer__1dhDC","pText":"profile-header_pText__GoNfV","descText":"profile-header_descText__3s4Yx"};